import Vue from 'vue';
import config from '@/config';

async function trackCategoryClick(categoryName) {
    try {
        // Get company code from localStorage if available
        let companyData = null;
        try {
            const corporateData = localStorage.getItem("ticket-office-corporate");
            if (corporateData) {
                companyData = JSON.parse(corporateData);
            }
        } catch (error) {
            console.error('Error parsing company data:', error);
        }

        // Get user email from localStorage if available
        let userEmail = null;
        let sessionId = null;
        try {
            const clientData = localStorage.getItem("client");
            if (clientData) {
                const userData = JSON.parse(clientData);
                userEmail = userData.login;
                sessionId = userData.token; // Use token as session ID
            }
        } catch (error) {
            console.error('Error parsing user data:', error);
        }

        // If no token/session, generate one
        sessionId = sessionStorage.getItem('tracking_session');
        if (!sessionId) {
            sessionId = 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
            try {
                sessionStorage.setItem('tracking_session', sessionId);
            } catch (error) {
                console.error('Error saving session:', error);
            }
        }

        const formData = new FormData();
        formData.append('category_name', categoryName);
        formData.append('user_email', userEmail || '');
        formData.append('url', window.location.href);
        formData.append('session_id', sessionId);

        if (companyData && companyData.code) {
            formData.append('company_code', companyData.code);
            formData.append('cnpj', companyData.cnpj);
        }

        // Fire and forget - don't await the response
        fetch(config.api + '/v1/tracking/category-click.php', {
            method: 'POST',
            body: formData
        }).catch(err => {
            console.error('Error sending tracking data:', err);
        });

        return true;
    } catch (error) {
        console.error('Error in tracking service:', error);
        return true;
    }
}

export const trackingService = {
    trackCategoryClick
}; 